module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh_cn":{"inLive":"直播中","pending":"即将开始","playback":"直播回放"},"zh_hk":{"inLive":"直播中","pending":"即將開始","playback":"直播回放"},"en":{"inLive":"Live","pending":"Coming soon","playback":"Replay"},"ja":{"inLive":"実況中","pending":"まもなく開始","playback":"リプレイ"}}')
  delete Component.options._Ctor
}
